import { getDemoProfile } from "../shared/industryCatalog";
import * as base from "./hiMedicalData";

const FALLBACK = {
  hospital: base.HOSPITAL,
  accent: "#1e3a5f",
  accentDeep: "#152a45",
  accentBlue: "#4a90b8",
  accentMint: "#5eb8a8",
};

export function getHospitalProfile(id) {
  return getDemoProfile("hospital", id) ?? FALLBACK;
}
